import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/view/components/ui/dialog";
import { Button } from "@/view/components/ui/button";
// import { Input } from "@/view/components/ui/input";
// import { Label } from "@/view/components/ui/label";
import { Switch } from "@/view/components/ui/switch";
// import { ImageUpload } from "@/view/components/ImageUpload";
// import { ColorPalette } from "@/view/components/ColorPalette";
import { TriStateSwitch } from "@/view/components/TriStatesSwitch";
import { useConfigPartner } from "./useConfigPartner";
import {
  Form,
  // FormField,
  // FormItem,
  // FormMessage,
} from "@/view/components/ui/form";
// import { X } from "lucide-react";
import {
  AlertDialog,
  AlertDialogTrigger,
} from "@/view/components/ui/alert-dialog";
import { EnableAndDisablePartners } from "../EnableAndDisablePartners";
import { TriStateEnum } from "@/app/entities/TriState";
// import { withCdn } from "@/app/utils/withCdn";

interface ConfigPartnerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  product: any;
}

export const ConfigPartner = ({
  open,
  onOpenChange,
  product,
}: ConfigPartnerProps) => {
  const {
    form,
    handleUpdateProduct,
    // isColorModalOpen,
    // setIsColorModalOpen,
    // partnerColor,
    // setPartnerColor,
    isSaving,
    createLink,
    // handleRemoveImage,
    productState,
    handleProductStateChange,
    isPatchingState,
    isSuperAdmin,
    handleCreateLinkChange,
    isPatchingCreateLink,
  } = useConfigPartner(product);

  // const { errors } = form.formState;

  const handleClose = () => {
    form.reset();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <Form {...form}>
        <DialogContent
          showCloseButton={false}
          className="max-w-lg"
          variant="center"
        >
          <form
            onSubmit={form.handleSubmit(handleUpdateProduct)}
            className="space-y-4"
          >
            <DialogHeader>
              <DialogTitle>Configurações do parceiro</DialogTitle>
            </DialogHeader>

            <div className="space-y-4">
              {/*
                Upload de imagem desabilitado: a imagem do parceiro não pode
                mais ser alterada por aqui. O sistema usa a imagem padrão
                (fallback em getPartnerData / getPartnerImage).
              <FormField
                control={form.control}
                name="image"
                render={({ field }) => (
                  <FormItem>
                    <ImageUpload
                      className="flex aspect-[3/1] h-full items-center justify-center p-0"
                      onChange={(files) => field.onChange(files.at(-1))}
                      value={field.value ? [field.value] : null}
                      render={({ value }) => {
                        const image = value?.[0] as File | string;
                        const defaultImage = typeof image === "string";

                        if (!image) {
                          return (
                            <ImageUpload.Placeholder className="h-full min-h-0 justify-center" />
                          );
                        }

                        return (
                          <div className="group relative h-full w-full overflow-hidden rounded-md">
                            <img
                              src={
                                defaultImage
                                  ? withCdn(image)
                                  : (image &&
                                      URL.createObjectURL(image as File)) ||
                                    ""
                              }
                              alt=""
                              className="h-full w-full object-cover"
                            />
                            <Button
                              type="button"
                              size="icon"
                              className="absolute right-2 top-2 h-5 w-5 rounded-full text-white opacity-0 transition-opacity group-hover:opacity-100"
                              onClick={handleRemoveImage}
                            >
                              <X size={12} />
                            </Button>
                          </div>
                        );
                      }}
                    />
                    <FormMessage className="text-xs" />
                  </FormItem>
                )}
              />
              */}
              {/*
                Título, Descrição e Cor de fundo desabilitados: não podem mais
                ser editados aqui. O sistema usa por padrão os valores do
                código (getPartnerLabel / getPartnerImage / getPartnerBgColor).
              <div className="space-y-1">
                <Label htmlFor="config-partner-label">Título</Label>
                <Input
                  id="config-partner-label"
                  placeholder="Título"
                  {...form.register("label")}
                />
                {errors.label?.message != null && (
                  <p className="mt-1 text-xs font-medium text-destructive">
                    {String(errors.label.message)}
                  </p>
                )}
              </div>
              <div className="space-y-1">
                <Label htmlFor="config-partner-subtitle">Descrição</Label>
                <Input
                  id="config-partner-subtitle"
                  placeholder="Descrição"
                  {...form.register("subtitle")}
                />
                {errors.subtitle && (
                  <FormMessage className="mt-1 text-xs">
                    {errors.subtitle.message}
                  </FormMessage>
                )}
              </div>

              <div className="space-y-1">
                <Label>Cor de fundo</Label>
                <div
                  className="flex cursor-pointer items-center justify-between gap-3 rounded-md border border-input p-2"
                  onClick={() => setIsColorModalOpen(true)}
                >
                  <div className="flex items-center gap-2">
                    <div
                      className="h-6 w-6 rounded border border-gray-300"
                      style={{ backgroundColor: partnerColor }}
                    />
                    <span className="text-sm font-medium text-black03">
                      {partnerColor}
                    </span>
                  </div>
                  <button
                    type="button"
                    className="mr-2 text-sm font-medium"
                    onClick={() => setIsColorModalOpen(true)}
                  >
                    Alterar cor
                  </button>
                </div>
              </div>
              */}
            </div>
            {/*
            <ColorPalette
              open={isColorModalOpen}
              onOpenChange={setIsColorModalOpen}
              value={partnerColor}
              onChange={setPartnerColor}
            />
            */}

            <div
              className="mt-4 flex items-center justify-between"
              onClick={(e) => e.stopPropagation()}
            >
              <p className="text-sm font-medium text-black03">
                Criar link de autocontração
              </p>
              <Switch
                checked={createLink}
                onCheckedChange={handleCreateLinkChange}
                disabled={isPatchingCreateLink}
              />
            </div>

            <div
              className="mt-4 flex w-full items-center justify-between"
              onClick={(e) => e.stopPropagation()}
            >
              <p className="text-sm font-medium text-black03">Produto</p>
              <div className="ml-auto">
                {isSuperAdmin ? (
                  <TriStateSwitch
                    value={productState}
                    onChange={handleProductStateChange}
                    disabled={isPatchingState}
                  />
                ) : (
                  <AlertDialog>
                    <AlertDialogTrigger asChild>
                      <div onClick={(e) => e.stopPropagation()}>
                        <Switch checked={productState === TriStateEnum.FULL} />
                      </div>
                    </AlertDialogTrigger>

                    <EnableAndDisablePartners
                      isActive={productState === TriStateEnum.FULL}
                      id={product?.name}
                    />
                  </AlertDialog>
                )}
              </div>
            </div>

            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                onClick={() => onOpenChange(false)}
              >
                Fechar
              </Button>
              <Button
                type="submit"
                className="text-white01"
                isLoading={isSaving}
              >
                Salvar
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Form>
    </Dialog>
  );
};
